<template>
  <ca-row vertical-offset="4">
    <ca-col offset="2" size="8">
      <ca-slimbox>
        <ca-row vertical-offset="2">
          <ca-col size="3">
            <ca-illustration name="rocket-in-construction"></ca-illustration>
          </ca-col>
          <ca-col size="9">
            <ca-heading text="Em breve uma nova experiência para você"></ca-heading>

            <ca-row vertical-offset="2">
              <ca-col>
                Estamos trabalhando em melhorias na plataforma neste exato momento
                para que sua experiência seja ainda melhor.
                Aguarde um momento e recarregue a página.
              </ca-col>
            </ca-row>

            <ca-row>
              <ca-col size="3">
                <ca-button href="https://dp.contaazul.com">
                  Recarregar página
                </ca-button>
              </ca-col>
            </ca-row>
          </ca-col>
        </ca-row>
      </ca-slimbox>
    </ca-col>
  </ca-row>
</template>

<script>
export default {
  name: 'MaitenancePage',
};
</script>
